import { render, staticRenderFns } from "./OmbudsmanTable.vue?vue&type=template&id=75876a66&scoped=true&"
import script from "./OmbudsmanTable.vue?vue&type=script&lang=js&"
export * from "./OmbudsmanTable.vue?vue&type=script&lang=js&"
import style0 from "./OmbudsmanTable.vue?vue&type=style&index=0&id=75876a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75876a66",
  null
  
)

export default component.exports